import React from "react";

export default function Header() {
  return (
    <div className="sticky top-0 z-50">
      <nav className="bg-gray-800 sticky top-0">
        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                {/* <img
                  className="h-8 w-8"
                  src="https://tailwindui.com/img/logos/workflow-mark-on-dark.svg"
                  alt="Workflow logo"
                ></img> */}
              </div>
              <span className="font-semibold text-xl tracking-tight text-white">
                <a href="/">National Parks DB</a>
              </span>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}
